import React, { Component } from 'react'
import { Button, TextField, FormControl, InputLabel, Select, MenuItem, Snackbar, Slide } from '@material-ui/core';
import { withRouter } from "react-router-dom";
import Http from '../../../Http';

const RutaOD = ({ origen = 1, destino = 1, ods = [], onChange, onDelete }) => {

  return (
    <div className='row'>
      <div className='col-sm-5'>
        <FormControl variant="outlined" fullWidth>
          <InputLabel>Origen</InputLabel>
          <Select
            value={origen}
            onChange={(e) => { onChange(e.target.value, 1) }}
          >
            {ods.map((od, i) => {
              return (<MenuItem value={od.id} key={i}>{od.sucursal_nombre}</MenuItem>)
            })}
          </Select>
        </FormControl>
      </div>
      <div className='col-sm-5'>
        <FormControl variant="outlined" fullWidth>
          <InputLabel>Destino</InputLabel>
          <Select
            value={destino}
            onChange={(e) => { onChange(e.target.value, 2) }}
          >
            {ods.map((od, i) => {
              return (<MenuItem value={od.id} key={i}>{od.sucursal_nombre}</MenuItem>)
            })}
          </Select>
        </FormControl>
      </div>
      <div className='col-sm-2' style={{ paddingTop: 10 }}>
        <Button variant='outlined' onClick={() => onDelete()}>Eliminar</Button>
      </div>
    </div>
  )
}

class Ruta extends Component {

  state = {
    rutas: [
      // { id_origen: 1, id_destino: 1 }
    ],
    ods: [],
    ruta_nombre: '',
    sbOpen: false,
    sbMsg: '',
  }

  componentDidMount() {
    // const { params } = this.props.match;
    // console.log(params)


    this.fillForm();
  }

  fillForm = async () => {
    try {
      let Res = await Http.get('ruta/form');
      // console.log(Res);
      if (!Res.error) {
        this.setState({ ods: Res.data.sucursales });
      }
    } catch (error) {

    }
    this.getForm();
  }

  getForm = async () => {
    const { params } = this.props.match;
    if (!params.id) return;
    try {
      let Res = await Http.get(`ruta/${params.id}/rutas`);
      // console.log(Res)
      if (!Res.error) {
        this.setState({
          rutas: Res.data.rutas,
          ruta_nombre: Res.data.ruta.ruta
        })
      }
    } catch (error) {

    }
  }

  agregarRuta = () => {
    const { params } = this.props.match;
    this.setState((state) => {
      state.rutas.push({ id_origen: 1, id_destino: 1, id: null, id_ruta: params.id || null });
      // console.log(state)
      return state;
    })
  }

  cambioRuta = (ri, valor, es = 1) => {
    this.setState((state) => {
      if (es === 1)
        state.rutas[ri].id_origen = valor;
      else
        state.rutas[ri].id_destino = valor;
      return state;
    })
  }

  borrarRuta = (ri) => {
    this.setState((state) => {
      state.rutas[ri].deleted = true;
      // state.rutas = state.rutas.filter((ruta, rri) => ri !== rri);
      return state;
    })
  }

  onSubmit = async (e) => {
    e.preventDefault();
    const { ruta_nombre, rutas } = this.state;
    const { params } = this.props.match;
    // console.log(rutas)
    try {
      let Res = await Http.post('ruta/save/rutas', {
        ruta: { ruta: ruta_nombre, id: params.id || null },
        rutas,
      })
      // console.log(Res)
      if (!Res.error) {
        this.setState({
          sbMsg: 'Guardado',
          sbOpen: true,
        })
        if (!params.id)
          this.setState({
            rutas: [],
            ruta_nombre: ''
          })
        this.props.onSave();
      }
    } catch (error) {

    }
  }

  render() {
    const { rutas, ods, ruta_nombre, sbOpen, sbMsg } = this.state;
    return (
      <div>
        <div className="form-box">
          <form onSubmit={this.onSubmit}>
            <div className='row'>
              <div className='col-10'>
                <TextField label='Nombre de la zona' variant='outlined' fullWidth value={ruta_nombre} onChange={(e) => { this.setState({ ruta_nombre: e.target.value }) }} />
              </div>
              <div className='col-2'>
                <Button fullWidth color='primary' onClick={this.agregarRuta}>Agregar ruta</Button>
              </div>
            </div>

            <div style={{ marginTop: 20 }}>
              {
                rutas.map((ruta, ri) => (!ruta.deleted && 
                  <RutaOD
                    key={ri}
                    ods={ods}
                    onChange={(val, es) => this.cambioRuta(ri, val, es)}
                    onDelete={() => this.borrarRuta(ri)}
                    origen={ruta.id_origen}
                    destino={ruta.id_destino}
                  />
                ))
              }
            </div>

            <div style={{ textAlign: 'right', marginTop: 15 }}>
              <Button variant='contained' color='primary' type='submit'>Guardar</Button>
            </div>
          </form>
        </div>

        <div>
          <Snackbar
            open={sbOpen}
            onClose={() => { this.setState({ sbOpen: false }) }}
            TransitionComponent={Slide}
            ContentProps={{
              'aria-describedby': 'message-id',
            }}
            message={<span id="message-id">{sbMsg}</span>}
          />
        </div>
      </div>
    )
  }
}

export default withRouter(Ruta)
